

































































































































import { mapActions } from 'vuex';
import { Component, Vue } from 'vue-property-decorator';
import FilePreview from '@/components/FilePreview.vue';

// Constants
const TAG_TYPES:any = {
	person: 'Persona',
	pet: 'Mascota',
	suitcase: 'Maleta'
};

@Component ({
	components: { FilePreview },
	methods: mapActions (['registerTag'])
})
export default class Register extends Vue
{
	// Properties

	user = {
		name: '',
		email: '',
		phone: ''
	};
	pet = {
		name: '',
		species: '',
		nationalid: null
	};
	suitcase = {
		name: ''
	};
	person = {
		name: ''
	};



	// Computed

	get tag ()
	{
		return this.$store.state.tag;
	}
	get tagType () : string
	{
		if (!this.tag)
			return '';
		return TAG_TYPES [this.tag.type];
	}



	// Events

	mounted ()
	{
		// @ts-ignore
		if (!this.tag)
			return this.$router.go (-1);
		// @ts-ignore
		if (this.tag.registered)
			return this.$router.go (-1);
	}



	// Methods

	getRegisterObject (file: string)
	{
		const o: any = {
			id: this.tag.id,
			type: this.tag.type,
			user: this.user
		};

		if (o.type == 'suitcase')
			o.suitcase = this.suitcase;
		if (o.type == 'pet')
		{
			o.pet = this.pet;
			o.pet.nationalid = o.pet.nationalid || null;
		}
		if (o.type == 'person')
			o.person = this.person;
		o.picture = file;

		return o;
	}

	async register ()
	{
		const isValid = await this.$validator.validateAll ();
		if (!isValid)
			return await this.setMessage (
				'Formulario incompleto',
				'Por favor, llene todos los campos del formulario',
				true
			);
		// @ts-ignore
		if (!this.$refs.preview.ready)
			return await this.setMessage (
				'Formulario incompleto',
				'Por favor, suba una fotografía',
				true
			);

		try
		{
			// @ts-ignore
			const file = await this.$refs.preview.upload ();
			// @ts-ignore
			await this.registerTag (this.getRegisterObject (file));
			// this.$router.go (-1);
			await this.setMessage (
				'OK!',
				`Hemos enviado un mail a tu dirección ${this.user.email}. ` +
				`Cuando lo recibas, podrás terminar la inscripción. ` +
				`Si lo deseas, puedes registrar de nuevo tu dispositivo ` +
				`escaneándolo nuevamente.`,
				false,
				'http://nomepierdo.cl/confirmar-email/');
		}
		catch (e)
		{
			await this.setMessage (
				'Error',
				e.message,
				true);
			console.log (e);
		}
	}

	setMessage (message: string, details: string, error = false, nextUrl: string | null = null)
	{
		return this.$store.dispatch ('setMessage', { message, details, error, nextUrl });
	}
}

